var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_86058675422713413961820461346233095539",
    d: "M9.682 8.636c1.233 0 2.233.957 2.233 2.137V23.59c0 1.18-1 2.136-2.233 2.136H2.985c-1.233 0-2.233-.956-2.233-2.136V10.773c0-1.18 1-2.137 2.233-2.137zm-4.465 11.75H2.985v2.137h2.232v-2.137zm4.465 0H7.45v2.137h2.232v-2.137zm-3.348-8.545c-1.85 0-3.35 1.435-3.35 3.204 0 1.77 1.5 3.205 3.35 3.205 1.848-.002 3.346-1.436 3.348-3.205 0-1.77-1.499-3.204-3.348-3.204zm0 1.159c1.233 0 2.232.977 2.232 2.182s-1 2.182-2.232 2.182c-1.233 0-2.233-.977-2.233-2.182S5.101 13 6.334 13zm.186-8.364c.907 0 1.777.351 2.418.976l-1.612 1.57c-.445-.434-1.167-.434-1.612 0L4.1 5.612c.642-.625 1.512-.976 2.419-.976zM6.334.273c2.093 0 4.1.774 5.581 2.152L10.32 3.909c-1.055-.987-2.49-1.54-3.986-1.537-1.496-.004-2.932.55-3.987 1.537L.752 2.425C2.232 1.047 4.24.273 6.334.273z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_273386212407889620141840499996881677142",
    d: "M-10 -3H22V29H-10z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_84252592655128934127942505576256917736",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(10 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_115115552215545885929236069042166854007",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_86058675422713413961820461346233095539"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_86058675422713413961820461346233095539"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_115115552215545885929236069042166854007)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_273386212407889620141840499996881677142"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_84252592655128934127942505576256917736)",
    xlinkHref: "#hinava_random_uuid_273386212407889620141840499996881677142"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.a542cbc2e7cfe364f75f206dcc744f5b.svg";
export { ForwardRef as ReactComponent };